export const FaqItem = (props: any) => {
  const { question, answer } = props;
  return (
    <div className="faq">
      <div
        className="faq__header collapsed"
        data-toggle="collapse"
        data-target="#@@id"
      >
        <p>{question}</p>
        <span></span>
      </div>
      <div className="faq__answer collapse" id="@@id">
        <p>{answer}</p>
      </div>
    </div>
  );
};
